module.exports = __webpack_public_path__ + "static/media/times-icon.8010f5d3.svg";